/**
 * @description 鉴权类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import CookieHelper from '../utils/cookieHelper'

class Authorize {
  /**
   * 构造函数，传入类和ajax方法
   * @param {*} thisClass
   * @param {*} ajaxFun
   */
  constructor (thisClass, ajaxFun) {
    this.ajaxAuthor = this._decorator(thisClass, ajaxFun)
  }
  // 装饰方法
  _decorator (that, fn) {
    const _self = that
    return function () {
      // console.info('decorator', arguments, _self)
      let args = arguments
      this._authorize(args)
      return fn.apply(_self, arguments)
    }
  }
  // 鉴权
  _authorize (args) {
    const cookieHelper = CookieHelper.getInstance()
    for (let i = 0; i < args.length; i++) {
      const item = args[i]
      if (item && item.auth) {
        delete item.auth
        if (!item.data) item.data = {}
        item.data.access_token = cookieHelper.getCookie('access_token')
        item.data.loginCustomerId = cookieHelper.getCookie('loginCustomerId')
        break
      }
    }
  }
  // session检查
  checkSession (res) {
    if (res.resultCode === '00000006' || res.resultCode === '00000007') {
      return true
    }
    return false
  }
  // 处理session过期
  handleSesstionTimeout () {
    setTimeout(() => window.location.replace('/login'), 1000)
  }
}

export default Authorize
